var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table-wrapper", {
    staticClass: "mb-12",
    attrs: {
      page: _vm.config.page,
      limit: _vm.config.limit,
      total: _vm.config.total,
      headers: _vm.config.headers,
      columns: _vm.config.columns,
      pagination: "",
    },
    on: { updateLimit: _vm.updatedLimit, next: _vm.next, prev: _vm.prev },
    scopedSlots: _vm._u(
      [
        _vm.$slots["header"]
          ? {
              key: "header",
              fn: function () {
                return [_vm._t("header")]
              },
              proxy: true,
            }
          : null,
        {
          key: "body",
          fn: function () {
            return [
              _vm.loading
                ? [_vm._v("Loading...")]
                : [_vm.empty ? [_vm._t("ifEmpty")] : [_vm._t("items")]],
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }